import { render, staticRenderFns } from "./W8V1.vue?vue&type=template&id=0b3385ca&scoped=true&"
import script from "./W8V1.vue?vue&type=script&lang=js&"
export * from "./W8V1.vue?vue&type=script&lang=js&"
import style0 from "./W8V1.vue?vue&type=style&index=0&id=0b3385ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3385ca",
  null
  
)

export default component.exports